<template>
    <b-modal
      ref="modal-modeloenvio"
      scrollable
      centered
      button-size="sm"
      size="xl"
      @hidden="hideModal"
      >
      <template #modal-title>
        <i class="fas fa-user"></i> ADICIONAR MODELO
      </template>
      <TemplateAdd
        ref="templateAdd"
        isModal
        @Back="hideModal"
      />
      <template #modal-footer>
        <div class="w-100 text-right">
          <button
            type="button"
            class="btn btn-third btn-sm"
            v-b-tooltip.hover
            :title="'Fechar'"
            @click="hideModal"
          >
            <i class="fas fa-times-circle"></i>
            <span class="d-md-down-none"> Fechar</span>
          </button>
        </div>
      </template>
    </b-modal>
  </template>

<script>
import TemplateAdd from '@/views/private/configurations/campaign/templates/components/add/campanhamodeloadd.vue'

export default {
  components: {
    TemplateAdd
  },
  data () {
    return {
      show: false
    }
  },
  methods: {
    showModal () {
      this.$refs['modal-modeloenvio'].show()
      this.onSetShow(true)
    },
    hideModal () {
      this.$refs['modal-modeloenvio'].hide()
      this.onHideModal()
    },
    onSetShow (value) {
      this.$nextTick(() => {
        this.show = value
      })
    },
    onEdit (data) {
      this.showModal()
      this.$nextTick(() => {
        this.$refs['templateAdd'].onEdit(data)
      })
    },
    onHideModal () {
      this.onSetShow(false)
      this.$emit('reload')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/configurations/lista-inteligente/components/add/modal/AddNewModeloEnvioModal.vue